<template>
  <div v-if="menu.Categories">
    <div v-if="menu.Categories.length > 0">
      <section
        v-for="category in menu.Categories"
        :key="category.ID"
        :id="'section-' + category.ID"
      >
        <div class="row">
          <div class="col-sm-12 category-title">
            <h2 id="combos">{{ category.Name | camelCase }}</h2>
          </div>
        </div>
        <div class="row menu-content">
          <div
            v-for="product in category.SubMenuItems"
            :key="product.ID"
            class="col-sm-12 col-md-12"
            :class="productClass"
          >
            <Product
              :product="menu.Products[product.ProductID]"
              :modifiers="menu.ModifierGroups"
              :category="product"
              :key="product.ID"
              :sectionId="category.ID"
              :parent-category="category"
            />
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <message />
    </div>
  </div>
</template>

<script>
import Product from "./Product";
import Message from "../../shared/Message";
import { $$ } from "./../../../sharedscripts/OO_jquery";
export default {
  name: "ProductList",
  components: { Product, Message },
  props: {
    menu: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      productClass: "col-xl-6",
      once: true
    };
  },
  updated() {
    if (this.isWC()) {
      this.calcProductClass();
      if (this.once) {
        window.addEventListener("resize", this.calcProductClass);
        this.once = false;
      }
    }
  },
  methods: {
    calcProductClass() {
      var containerWidth = $$(".oo-module").outerWidth();
      if (containerWidth > 992) {
        this.productClass = "col-xl-6";
      } else {
        this.productClass = "col-xl-12";
      }
      this.$emit("update-containerWidth", containerWidth);
    }
  }
};
</script>
